/**
 * @module
 * @category State
 */

import { devtools, persist } from '@bomdisoft/store/middleware';
import { create } from '@bomdisoft/store/react';

export enum SharedDialogsEnum {
  PRIVACY_AND_TERMS = 'Privacy and Terms',
  TERMS_OF_SERVICE = 'Terms Of Service',
  PRIVACY_POLICY = 'Privacy Policy',
}

type SharedDialogStore = {
  activeDialog: string;
  stack: string[];
  toggleDialog: (dialog: string) => void;
  closeDialog: () => void;
};

export const useSharedDialogStore = create<SharedDialogStore>()(
  devtools(
    persist(
      (set, get) => ({
        activeDialog: '',
        closeDialog: () => {
          const state = get();
          set({
            activeDialog: state.stack[state.stack.length - 1] || '',
            stack: state.stack.length > 1 ? state.stack.slice(0, state.stack.length - 2) : [],
          });
        },
        stack: [],

        toggleDialog: (dialog: string) => {
          const state = get();
          if (state.activeDialog) set({ stack: [...state.stack, state.activeDialog] });
          set({ activeDialog: dialog });
        },
      }),
      { name: 'bomdisoft-shared-dialog-storage' },
    ),
  ),
);
